import { LOCALE_ID, Provider } from '@angular/core';
import { ConfigService } from './config.service';

export class LocaleId extends String {

  constructor(
    private configSvc: ConfigService,
  ) {
    super();
  }

  toString(): string {
    return this.getLocaleId();
  }

  valueOf(): string {
    return this.toString();
  }

  // private

  private getLocaleId(): string {
    switch (this.configSvc.language) {
      case 39:
        return 'it';
      default:
        if (this.configSvc.currency.name === 'ZAR') {
          return 'en-ZA';
        }

        return 'en';
    }
  }
}

export const LocaleProvider: Provider = {
  provide: LOCALE_ID,
  useClass: LocaleId,
  deps: [ConfigService],
};